define('baseline/colors',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.trackColor = exports.mapColor = exports.pathColor = exports.landColor = exports.deployColor = exports.exitColor = exports.laserColor = exports.defaultColor = void 0;
    // Track and laser profile color
    exports.defaultColor = "#6b00ff";
    exports.laserColor = "#ee0000";
    exports.exitColor = "#6f00ff";
    exports.deployColor = "#1d1";
    exports.landColor = "#a52";
    var modes = {
        Ground: "#952",
        Plane: "#d22",
        Freefall: "#11e",
        Wingsuit: "#6b00ff",
        Canopy: "#1d1"
    };
    // Color by flight mode for charts
    function pathColor(mode) {
        return modes[mode] || "#bbb";
    }
    exports.pathColor = pathColor;
    // Color by flight mode for maps
    function mapColor(mode) {
        return modes[mode] || "#6b00ff";
    }
    exports.mapColor = mapColor;
    // Color of a track when highlighted, or not
    function trackColor(track) {
        if (track.trackType === "laser") {
            return exports.laserColor;
        }
        else {
            return track.color || exports.defaultColor;
        }
    }
    exports.trackColor = trackColor;
});
//# sourceMappingURL=/assets/javascripts/baseline/colors.js.map;
